<template>
  <div class="container">
    <Head2></Head2>
    <div class="mainArea">
      <div class="sortTitle" v-if="productInfo.topcatename === ''">
        {{ $t("pages.detail.home") }} > {{ productInfo.childcatename }} >{{
          productInfo.thirdcatename
        }}
        > {{ productInfo.product_name }}
      </div>
      <div class="sortTitle" v-else-if="productInfo.childcatename === ''">
        {{ $t("pages.detail.home") }} > {{ productInfo.thirdcatename }} >
        {{ productInfo.product_name }}
      </div>
      <div class="sortTitle" v-else>
        {{ $t("pages.detail.home") }} > {{ productInfo.topcatename }} >
        {{ productInfo.childcatename }} >{{ productInfo.thirdcatename }} >
        {{ productInfo.product_name }}
      </div>
      <div class="production">
        <div class="productionDetail">
          <div class="productionDetailLeft">
            <imgSwiperVue :imgList="imgList" v-if="updateModel"></imgSwiperVue>
            <div
              class="collectArea"
              v-if="productInfo.is_collect != 1"
              @click="addCollect()"
            >
              <img src="../assets/images/heart.png" />
              <div>{{ $t("pages.detail.collect") }}</div>
            </div>
            <div class="collectArea" v-else>
              <img
                src="../assets/images/hearted.png"
                @click="deleteCollect(productInfo.collect_id)"
              />
              <div>{{ $t("pages.detail.collected") }}</div>
            </div>
          </div>
          <div>
            <div class="productTitle">{{ productInfo.product_name }}</div>
            <div class="parameterArea">
              <ul class="parameter">
                <li>
                  {{ $t("pages.detail.model_label") }}{{ productInfo.model }}
                </li>
                <li>
                  {{ $t("pages.detail.material_label")
                  }}{{ productInfo.material }}
                </li>
                <li>
                  {{ $t("pages.detail.size_label") }}{{ productInfo.size }}
                </li>
              </ul>
              <div class="parameterRateArea">
                <Rate
                  :max="5"
                  :selected="score"
                  :read-only="true"
                  v-if="updateModel"
                ></Rate>
              </div>
            </div>
            <div class="proDes">
              {{ $t("pages.detail.description") }}{{ productInfo.short_intro }}
            </div>
            <div class="skuArea">
              <div class="skuTopLeft">
                {{ $t("pages.detail.spec_label") }}{{ skutext }}
              </div>
              <div
                class="skuBtn"
                @click="SetChoose(0, 0, skuPrice, skuTax, '')"
              >
                {{ $t("pages.detail.rechoose") }}
              </div>
            </div>
            <div class="skuDetial">
              <div class="skuDetailTop">
                {{ $t("pages.detail.unit_price_label")
                }}<span>{{ $t("pages.detail.price_unit") }}{{ skuPrice }}</span>
              </div>
              <div class="skuDetailTop skuDetailFlex">
                <div class="skuDetailLi">
                  {{ $t("pages.detail.total_price_excl")
                  }}<span>{{ $t("pages.detail.price_unit") }}{{ TotalMoney }}</span>
                </div>
                <div class="skuDetailLi skuDetailLiTotel">
                  {{ $t("pages.detail.total_price_incl")
                  }}<span>{{ $t("pages.detail.price_unit") }}{{ TotalAmount }}</span>
                </div>
              </div>
            </div>
            <div class="logisticsDate">
              {{ $t("pages.detail.expected_ship_label") }}
              <div class="seven">
                {{ $t("pages.detail.days_text", { num: 7 }) }}
              </div>
            </div>
            <div class="downloadFlex">
              <div class="logisticsPrice">
                {{ $t("pages.detail.logistics_price") }}
              </div>
              <div class="downloadFlex" v-if="downloadUrl != ''">
                <div>{{ $t("pages.detail.product_catalog") }}</div>
                <div class="downloadbtn" @click="downloadFile()">
                  {{ $t("pages.detail.download_btn") }}
                </div>
              </div>
            </div>

            <div class="payWay" v-if="currentLanguage === 'zh-CN'">
              {{ $t("pages.detail.pay_method_label")
              }}<img
                src="../assets/images/wechartSmall.png"
                class="payIcon"
              />{{ $t("pages.detail.wechat")
              }}<img src="../assets/images/zhiSmall.png" class="payIcon" />{{
                $t("pages.detail.alipay")
              }}<img src="../assets/images/carSmall.png" class="payIcon" />{{
                $t("pages.detail.online_pay")
              }}
            </div>
            <div class="btns">
              <Counter
                @messageSent="handleMessage"
                :val="qty"
                :id="productId"
              ></Counter>
              <div class="addBtn" @click="addCart()">
                {{ $t("pages.detail.add_to_cart") }}
              </div>
              <div class="buyBtn" @click="buyNow()" v-if="currentLanguage === 'zh-CN'">
                {{ $t("pages.detail.buy_now") }}
              </div>
            </div>
            <div
              class="note"
              v-html="
                $t('pages.detail.wholesale_note', {
                  online_service:
                    '<span>' + $t('pages.detail.online_service') + '</span>',
                })
              "
            ></div>
          </div>
        </div>
        <div class="productionList">
          <div class="productionListTitle">
            <img src="../assets/images/arrowLeftBlack.png" />
            <span>{{ $t("pages.detail.more_products") }}</span>
            <img src="../assets/images/arrowRightBlack.png" />
          </div>
          <div
            class="productionli"
            v-for="(item, index) in recommendproductList"
            :key="item.id"
          >
            <img :src="item.cover_image" class="proImg3" />
            <div>
              <div class="productionLiTitle">{{ item.product_name }}</div>
              <div class="productionLiName">{{ item.cate_name }}</div>
              <div class="productionLiRate">
                {{ $t("pages.detail.rating_label", { score: 5.0 }) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tableArea">
        <div class="tableAreaTitle">{{ $t("pages.detail.table_title") }}</div>
        <div class="tableAreaMiddle">
          <table>
            <thead>
              <th
                v-for="(item, index) in productInfo.attr_list"
                :key="item.attr_id"
              >
                {{ item.attr_value }}
              </th>
              <th>{{ $t("pages.detail.operation") }}</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in skuInfoList" :key="item.id">
                <td
                  v-for="(itemAttr, indexAttr) in item.attr_list"
                  :key="itemAttr.attr_id"
                >
                  {{ itemAttr.attr_value }}
                </td>
                <td>
                  <div class="tdInner" v-if="skuId == item.id">
                    <div
                      class="tdBtnOver"
                      @click="
                        SetChoose(
                          1,
                          item.id,
                          item.sku_price,
                          item.sku_tax,
                          item.sku_text
                        )
                      "
                    >
                      {{ $t("pages.detail.chosen") }}
                    </div>
                  </div>
                  <div class="tdInner" v-if="skuId != item.id">
                    <div
                      class="tdBtnNo"
                      @click="
                        SetChoose(
                          1,
                          item.id,
                          item.sku_price,
                          item.sku_tax,
                          item.sku_text
                        )
                      "
                    >
                      {{ $t("pages.detail.choose") }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="paginationArea">
            <PaginationVue
              :TotalCount="totalcount"
              :pageSize="10"
              @pageChenged="handlePage"
            >
            </PaginationVue>
          </div>
        </div>
      </div>

      <div class="detailAndEva">
        <div class="tabArea">
          <div
            class="tabli"
            :class="{ active: tabActive == 0 }"
            @click="tabClick(0)"
          >
            {{ $t("pages.detail.product_details") }}
          </div>
          <div
            class="tabli"
            :class="{ active: tabActive == 1 }"
            @click="tabClick(1)"
          >
            {{
              $t("pages.detail.product_reviews", {
                count: productInfo.evacount,
              })
            }}
          </div>
        </div>
        <div class="tabContent desArea" v-if="tabActive == 0">
          <div v-html="productInfo.product_desc"></div>
        </div>
        <div class="tabContent" v-if="tabActive == 1">
          <div class="eva" v-for="(item, index) in evalist" :key="item.id">
            <div class="evaName">{{ item.member_name }}</div>
            <div class="evaRateArea">
              <div class="evaRate">
                <Rate :max="5" :selected="item.score" :read-only="true"></Rate>
                <div class="evaRateText">{{ item.score.toFixed(1) }}</div>
              </div>
              <div class="evaDetail">
                <div class="evaDetailText">{{ item.content }}</div>
                <div class="evaImgs">
                  <img
                    :src="image"
                    class="evaImg"
                    v-for="(image, index) in item.eva_images"
                  />
                </div>
              </div>
            </div>
            <div class="evaText">{{ item.gmt_eva }}</div>
          </div>
          <div class="paginationArea">
            <PaginationVue
              :TotalCount="evatotalcount"
              :pageSize="10"
              @pageChenged="handleEvaPage"
            >
            </PaginationVue>
          </div>
        </div>
      </div>
    </div>
    <Foot2></Foot2>
  </div>
</template>

<script>
import Head2 from "../components/head2.vue";
import Foot2 from "../components/foot2.vue";
import imgSwiperVue from "../components/imgSwiper.vue";
import Rate from "../components/rate.vue";
import Counter from "../components/counter.vue";
import PaginationVue from "../components/pagination.vue";
import parseFloat from "core-js/library/fn/number/parse-float";
export default {
  components: {
    Head2,
    Foot2,
    imgSwiperVue,
    Rate,
    Counter,
    PaginationVue,
  },
  data() {
    return {
      tabActive: 0,
      productId: 0,
      productInfo: {},
      skutext: "",
      skuId: 0,
      qty: 1,
      skuPrice: 0,
      skuTax: 0,
      TotalMoney: 0,
      TotalAmount: 0,
      skuInfoList: [],
      imgList: [],
      updateModel: false,
      recommendproductList: [],
      pageIndex: 1,
      totalcount: 1,
      score: 0,
      evapageIndex: 1,
      evatotalcount: 1,
      evalist: [],
      downloadUrl: "",
      downName: "",
	  currentLanguage: localStorage.getItem("locale-lang") || "zh-CN",
    isLogin: false,
    };
  },
  created() {
    this.checkLogin();
    this.productId = this.$route.query.id;
    //console.log(this.productId);
    this.getProductInfo();
    this.getSkuInfo();
    this.addRecord();
    this.getEvaList();
  },
  mounted() {
    window.scrollTo(0, 0); // 滚动到顶部
  },
  methods: {
    checkLogin() {
      this.$scUtil.checkLogin(this, (res) => {
        this.isLogin = res;
        // if (!res) {
        //   this.$router.push({ name: "LoginVue" });
        // }
      });
    },
    tabClick(idx) {
      this.tabActive = idx;
    },
    fixed2Value(num) {
      return Math.round(num * 100) / 100;
    },
    SetChoose(type, id, price, tax, text) {
      var isLogin=this.isLogin;
      if(!isLogin)
      {
        this.$router.push({ name: "LoginVue" });
        return;
      }
      if (type == 1) {
        this.skuId = id;
        this.skutext = text;
        this.skuPrice = price;
        this.skuTax = tax;
        if (isNaN(this.skuPrice) || isNaN(this.skuTax)) {
          this.TotalMoney = "----";
          this.TotalAmount = "----";
        } else {
          this.TotalMoney = this.fixed2Value(
            parseFloat(this.skuPrice * this.qty)
          );
          this.TotalAmount = this.fixed2Value(
            parseFloat((this.skuPrice + this.skuTax) * this.qty)
          );
        }
      } else {
        this.skuId = 0;
        this.skutext = "";
        this.skuPrice = "----";
        this.skuTax = "----";
        if (isNaN(this.skuPrice) || isNaN(this.skuTax)) {
          this.TotalMoney = "----";
          this.TotalAmount = "----";
        } else {
          this.TotalMoney = this.fixed2Value(
            parseFloat(this.skuPrice * this.qty)
          );
          this.TotalAmount = this.fixed2Value(
            parseFloat((this.skuPrice + this.skuTax) * this.qty)
          );
        }
      }
    },
    downloadFile() {
      //console.log(item.detail_files[0].url)
      var a = document.createElement("a"); // 创建一个<a></a>标签
      a.href = this.downloadUrl; //重点（如测试发现下载文件不存在/找不到，检查路径）
      a.download = this.downName; // 设置下载文件文件名
      a.style.display = "none"; // 隐藏a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove();
    },
    getProductInfo() {
      this.$scUtil.axiosPost(
        this,
        "ProductApi/GetProductInfo",
        {
          productId: this.productId,
          userName: localStorage.getItem("username"),
        },
        (res) => {
          if (res.code == 100) {
            this.productInfo = res.data;
            this.skuPrice = "----";
            this.skuTax = "----";
            this.TotalMoney = "----";
            this.TotalAmount = "----";
            this.imgList = this.productInfo.product_images;
            if (this.productInfo.evacount != 0) {
              this.score = this.productInfo.score / this.productInfo.evacount;
            }
            this.updateModel = true;
            this.getRecommendListInfo();
            if (this.productInfo.third_cate_id != 0) {
              this.getInfo(this.productInfo.third_cate_id);
            } else {
              if (this.productInfo.child_cate_id != 0) {
                this.getInfo(this.productInfo.child_cate_id);
              } else {
                this.getInfo(this.productInfo.top_cate_id);
              }
            }
            // debugger;

            // console.log(this.list)
          }
        }
      );
    },
    getInfo(id) {
      this.$scUtil.axiosPost(
        this,
        "CategoryApi/GetInfo",
        {
          cateId: id,
        },
        (res) => {
          if (res.code == 100) {
            if (res.data.detail_files != "" && res.data.detail_files != null) {
              this.downName = res.data.name;
              this.downloadUrl = res.data.detail_files[0].url;
            }
          }
        }
      );
    },
    getSkuInfo() {
      this.skuInfoList = [];
      this.$scUtil.axiosPost(
        this,
        "ProductApi/GetSkuList",
        {
          productId: this.productId,
          pageIndex: this.pageIndex,
          pageSize: 10,
          userName: localStorage.getItem("username"),
        },
        (res) => {
          if (res.code == 100) {
            this.skuInfoList = res.data;
            this.totalcount = res.totalcount;
          }
        }
      );
    },
    getRecommendListInfo() {
      this.$scUtil.axiosPost(
        this,
        "ProductApi/GetRecommendList",
        {
          cateId: this.productInfo.third_cate_id,
          count: 6,
        },
        (res) => {
          if (res.code == 100) {
            this.recommendproductList = res.data.filter(
              (item) => item.id != this.productId
            );
            //console.log(this.recommendproductList);
          }
        }
      );
    },
    handleMessage(message) {
      this.qty = message.number;
      if (isNaN(this.skuPrice) || isNaN(this.skuTax)) {
        this.TotalMoney = "----";
        this.TotalAmount = "----";
      } else {
        this.TotalMoney = this.fixed2Value(
          parseFloat(this.skuPrice * this.qty)
        );
        this.TotalAmount = this.fixed2Value(
          parseFloat((this.skuPrice + this.skuTax) * this.qty)
        );
      }
    },
    handlePage(message) {
      console.log(message);
      this.pageIndex = message;
      this.getSkuInfo();
    },
    addRecord() {
      this.$scUtil.checkLogin(this, (res) => {
        if (res) {
          this.$scUtil.axiosPut(
            this,
            "RecordApi/Add",
            {
              productId: this.productId,
              userName: localStorage.getItem("username"),
            },
            (res) => {}
          );
        }
      });
    },
    addCollect() {
      this.$scUtil.axiosPut(
        this,
        "CollectApi/Add",
        {
          productId: this.productId,
          userName: localStorage.getItem("username"),
        },
        (res) => {
          console.log(res.code);
          if (res.code == 100) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getProductInfo();
            return;
          }
        }
      );
    },
    deleteCollect(id) {
      this.$scUtil.axiosPost(
        this,
        "CollectApi/Delete",
        {
          id: id,
        },
        (res) => {
          console.log(res.code);
          if (res.code == 100) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getProductInfo();
            return;
          }
        }
      );
    },
    addCart() {
      //this.$message({ message: "恭喜你，这是一条成功消息",type: "success"});
      if (this.skutext == "") {
        this.$message(this.$t("pages.detail.select_model_first"));
        return;
      }
      try {
        this.$scUtil.axiosPut(
          this,
          "ShoppingCartApi/Add",
          {
            productId: this.productId,
            skuId: this.skuId,
            number: this.qty,
            userName: localStorage.getItem("username"),
          },
          (res) => {
            console.log(res.code);
            if (res.code == 100) {
              this.$message({
                message: res.message,
                type: "success",
              });
              return;
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    buyNow() {
      //this.$message({ message: "恭喜你，这是一条成功消息",type: "success"});
      if (this.skutext == "") {
        this.$message(this.$t("pages.detail.select_model_first"));
        return;
      }
      var parameter = [];
      parameter.push({
        skuId: this.skuId,
        number: this.qty,
      });
      localStorage.setItem("payList", JSON.stringify(parameter));
      this.$router.push({
        name: "ConfirmOrderVue",
      });
    },
    getEvaList() {
      this.$scUtil.axiosPut(
        this,
        "EvaluateApi/GetRecordList",
        {
          pageIndex: this.evapageIndex,
          pageSize: 10,
          productId: this.productId,
        },
        (res) => {
          if (res.code == 100) {
            this.evalist = res.data;
            this.evatotalcount = res.totalcount;
          }
        }
      );
    },
    handleEvaPage(message) {
      console.log(message);
      this.evapageIndex = message;
      this.getEvaList();
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ebecee;
}

.sortTitle {
  font-size: 13px;
  color: #333333;
  height: 44px;
  line-height: 44px;
}

.production {
  display: flex;
  align-items: flex-start;
}

.mainArea {
  width: 1200px;
}

.productionDetail {
  background-color: #fff;
  width: 972px;
  height: 481px;
  padding: 27px;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
}

.collectArea {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  font-size: 13px;
  color: #333333;
}

.collectArea img {
  margin-right: 5px;
}

.productionDetailLeft {
  margin-right: 21px;
}

.star-rating {
  cursor: pointer;
  font-size: 0;
  list-style-type: none;
  padding-left: 0;
  user-select: none;
}

.star-rating li {
  display: inline-block;
  margin-right: 2px;
}

.star-rating li.active {
  color: #f0d52d;
}

.star-rating.read-only li.active:hover {
  cursor: not-allowed;
}

.star-rating.read-only li.active {
  cursor: not-allowed;
}

.productTitle {
  font-size: 18px;
  color: #222222;
}

.parameter {
  font-size: 13px;
  color: #333333;
  display: flex;
  flex-wrap: wrap;
  width: 343px;
  margin-top: 10px;
}

.parameter li {
  width: 166px;
  list-style: none;
  line-height: 30px;
}

.proDes {
  font-size: 13px;
  color: #333333;
  line-height: 30px;
}

.parameterArea {
  display: flex;
  align-items: flex-start;
}

.rateText {
  font-size: 13px;
  color: #0380fe;
  margin-left: 8px;
  margin-top: -5px;
}

.rateText span {
  text-decoration: underline;
  text-underline-offset: 3px;
  margin-left: 8px;
}

.parameterRateArea {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.skuArea {
  margin-top: 12px;
}

.skuTop {
  width: 560px;
  height: 36px;
  background-color: #d9ecff;
  font-size: 13px;
  color: #222222;
  display: flex;
  align-items: center;
  padding-left: 15px;
  box-sizing: border-box;
}

.skuTopLeft {
  width: 480px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.skuBtn {
  color: #0380fe;
  font-size: 13px;
  font-weight: bolder;
}

.skuDetial {
  width: 560px;
  background-color: #ebf5ff;
  padding: 8px 15px;
  box-sizing: border-box;
}

.skuDetailTop {
  font-size: 13px;
  color: #333333;
  line-height: 30px;
}

.skuDetailTop span {
  color: #db050f;
}

.skuDetailFlex {
  display: flex;
  align-items: center;
}

.skuDetailLi {
  flex: 1;
}

.skuDetailLiTotel {
  font-weight: bolder;
}

.skuDetailLiTotel span {
  font-size: 18px;
}

.logisticsDate {
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.seven {
  width: 35px;
  height: 19px;
  border: 1px solid #0380fe;
  color: #0380fe;
  font-size: 13px;
  text-align: center;
  line-height: 19px;
}

.logisticsPrice {
  color: #333333;
  font-size: 13px;
  margin-top: 12px;
  margin-right: 30px;
}

.payWay {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #333333;
  margin-top: 15px;
}

.payIcon {
  margin: 0 10px 0 13px;
}

.note {
  font-size: 13px;
  color: #333333;
}

.note span {
  color: #0380fe;
}

.addBtn {
  width: 156px;
  height: 42px;
  background: #0380fe;
  border: 1px solid #0380fe;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 42px;
  margin-left: 24px;
  border-radius: 5px;
  cursor: pointer;
}

.buyBtn {
  width: 156px;
  height: 42px;
  background: #fff;
  border: 1px solid #0380fe;
  color: #0380fe;
  font-size: 16px;
  text-align: center;
  line-height: 42px;
  margin-left: 24px;
  border-radius: 5px;
  cursor: pointer;
}

.btns {
  display: flex;
  align-items: center;
  margin: 15px 0;
}

.productionList {
  width: 242px;
  height: 481px;
  background: #fff;
  margin-left: 10px;
  padding: 0 10px;
}

.productionListTitle {
  display: flex;
  height: 38px;
  align-items: center;
  justify-content: center;
}

.productionListTitle span {
  width: 120px;
  text-align: center;
  font-size: 14px;
  color: #000000;
}

.productionli {
  width: 219px;
  height: 79px;
  border: 1px solid #e2e2e2;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 9px;
}

.proImg3 {
  width: 60px;
  min-width: 60px;
  height: 60px;
  border: 1px solid #e6e6e6;
  margin-right: 10px;
}

.productionLiTitle {
  font-size: 13px;
  color: #000000;
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.productionLiName {
  font-size: 12px;
  color: #888888;
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 5px;
}

.productionLiRate {
  font-size: 12px;
  color: #888888;
  margin-top: 5px;
}

.productionLiRate span {
  color: #0380fe;
}

.tableArea {
  width: 1200px;
  background-color: #fff;
  margin-top: 15px;
}

.tableAreaTitle {
  width: 1200px;
  height: 44px;
  line-height: 44px;
  padding-left: 35px;
  box-sizing: border-box;
  border-bottom: 1px solid #e2e2e2;
  color: #333333;
  font-size: 14px;
}

.tableAreaMiddle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 14px;
}

.tableArea table {
  width: 1176px;
  border-collapse: collapse;
}

.tableArea table thead {
  width: 1176px;
  height: 74px;
  background-color: #e8e8e8;
}

.tableArea table thead th {
  text-align: center;
  font-size: 14px;
  color: #222222;
  border: 1px solid #fff;
}

.tableArea table tr {
  height: 41px;
  font-size: 13px;
  text-align: center;
  color: #333333;
}

.tableArea table tr td {
  border: 1px solid #e2e2e2;
  height: 41px;
}

.tdInner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tableArea table tr td:nth-child(1) {
  border-left: 1px solid #fff;
}

.tableArea table tr td:nth-last-child(1) {
  border-right: 1px solid #fff;
}

.tableArea table tr:nth-child(1) td {
  border-top: 1px solid #fff;
}

.tableArea table tr:hover {
  background-color: #ebf5ff;
}

.tdBtnOver {
  width: 54px;
  height: 22px;
  background: #0380fe;
  color: #fff;
  font-size: 13px;
  text-align: center;
  line-height: 22px;
  border-radius: 4px;
}

.tdBtnNo {
  width: 54px;
  height: 22px;
  border: 1px solid #0380fe;
  color: #0380fe;
  font-size: 13px;
  text-align: center;
  line-height: 22px;
  border-radius: 4px;
}

.detailAndEva {
  width: 1200px;
  background-color: #fff;
  margin: 14px 0 10px 0;
}

.tabArea {
  width: 1200px;
  height: 51px;
  line-height: 51px;
  border-bottom: 1px solid #e2e2e2;
  display: flex;
  padding-left: 37px;
  box-sizing: border-box;
}

.tabli {
  font-size: 14px;
  color: #333333;
  height: 51px;
  margin-right: 65px;
}

.tabli.active {
  font-size: 14px;
  font-weight: bolder;
  color: #0380fe;
  border-bottom: 1px solid #0380fe;
}

.eva {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #e2e2e2;
  margin: 0 30px;
  padding: 18px 0;
  width: 1140px;
  box-sizing: border-box;
}

.evaName {
  width: 67px;
  font-size: 13px;
  color: #000000;
}

.evaRate {
  display: flex;
  align-items: center;
}

.evaRateText {
  font-size: 13px;
  color: #0380fe;
  margin-left: 5px;
}

.evaRateArea {
  flex: 1;
}

.evaDetail {
  width: 100%;
  margin-top: 13px;
}

.evaDetailText {
  width: 100%;
  word-break: break-all;
  font-size: 13px;
  line-height: 25px;
}

.evaText {
  font-size: 13px;
  color: #888888;
}

.tabContent {
  display: flex;
  flex-direction: column;
  width: 1200px;
  align-items: left;
  margin-left: 30px;
}

.evaImgs {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.evaImg {
  width: 53px;
  height: 53px;
  min-width: 53px;
  border: 1px solid #e2e2e2;
  margin: 0 12px 12px 0;
}

.desArea {
  padding: 20px 0;
}

.paginationArea {
  width: 100%;
  padding: 30px 0;
  display: flex;
  justify-content: center;
}

.downloadFlex {
  display: flex;
  align-items: center;
}

.downloadFlex .downloadFlex {
  font-size: 12px;
  margin-top: 12px;
  color: #333333;
}

.downloadbtn {
  padding: 2px 15px;
  border: 1px solid #0380fe;
  color: #0380fe;
  cursor: pointer;
  margin-left: 10px;
}

.downloadbtn:hover {
  background: #0380fe;
  color: #fff;
  border: 1px solid #0380fe;
}

.table table-bordered {
  border-collapse: collapse;
  width: 100%;
  max-width: 1000px;
  margin: 20px auto;
  font-family: Arial, sans-serif;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

caption {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
